export const PROD_BINS = ['170740016341', '030840001884', '020928651072', '910402451195', '990440000385'];
export const TEST_BINS = ['990440000385', '910227351108'];

export const getAllowedBins = () => {
	const hostname = window.location.hostname;

	if (hostname.includes('test') || hostname.includes('dev') || hostname === 'localhost') {
		return TEST_BINS;
	}

	// Иначе отдаем боевые
	return PROD_BINS;
};